export default __webpack_public_path__ + "static/DEIPage-pattern-large-lightblue-984dfde3c92591d5da9266dc986d2f61.png";